// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3icZi","vLegacy":"SelectSecondary_vLegacy__3WxyA","error":"SelectSecondary_error__31Cs9","disabled":"SelectSecondary_disabled__2P7sL"};